// src/services/accessCodeRpc.js
//
// 039-01: the early-access gate asks the server, never the table. The browser
// roles can no longer read access_codes (or list users' referral codes); the
// security-definer RPC validate_access_code answers with
//   { valid, is_referral, reason: null | 'empty' | 'expired' | 'limit_reached' | 'invalid' }
// and normalizes the code (upper / trim) itself.
//
// checkAccessCode keeps two failures apart, because MainAppLayout treats them
// differently: an explicit answer (valid: false + reason) revokes a stored
// grant; `transportError` (the rpc call failed, threw, or answered something
// that is not the jsonb above) is not an answer about the code at all.

import { supabase } from '../lib/supabase';

const MESSAGES = {
  expired: 'Access code has expired',
  limit_reached: 'Code limit reached',
  invalid: 'Invalid access code',
  empty: 'Invalid access code',
};

export async function checkAccessCode(code) {
  let data;
  let error;
  try {
    ({ data, error } = await supabase.rpc('validate_access_code', { p_code: code }));
  } catch (e) {
    error = e;
  }
  if (error || !data || typeof data.valid !== 'boolean') {
    return { valid: false, isReferral: false, reason: null, transportError: error || { message: 'Unexpected validate_access_code answer' } };
  }
  if (data.valid) {
    return { valid: true, isReferral: data.is_referral === true, reason: null, transportError: null };
  }
  const reason = data.reason || 'invalid';
  return { valid: false, isReferral: false, reason, message: MESSAGES[reason] || MESSAGES.invalid, transportError: null };
}
